import type { MenuNode } from '../../../common/hooks/useMenuState';
import type { SectionTree, SectionTreeItem } from './SectionMenu.types';

import { appConfig } from '../../../../appConfig';
import { formatShowAllCategoryLabel } from '../../utils/showAllCategoryLabel';
import { buildEcommerceSectionUrl } from '../../utils/urlEcommerceUtils';

export const mapToMenu = (item: SectionTreeItem, ancestors: MenuNode[], trail: string[] = []) => {
    const menuNode: MenuNode = {
        id: item.id,
        name: item.name,
        url: buildEcommerceSectionUrl([...trail, item.escapedName]),
        segmentUrl: item.escapedName,
        ancestors: [...ancestors],
        nodes: [],
        type: 'Link',
    };

    if (item.children.length) {
        menuNode.displayName = formatShowAllCategoryLabel(item.name);
        item.children.forEach((x) => {
            const childNode = mapToMenu(
                x,
                [menuNode, ...menuNode.ancestors],
                [...trail, item.escapedName],
            );
            menuNode.nodes.push(childNode);
        });
    }

    return menuNode;
};

export const buildSectionMenu = (tree?: SectionTree) => {
    const rootNode: MenuNode = {
        id: appConfig.coopSettings.ecommerce.page.contentId,
        parentId: undefined,
        name: appConfig.coopSettings.ecommerce.page.menuName,
        ancestors: [],
        nodes: [],
        url: appConfig.coopSettings.ecommerce.url,
        segmentUrl: appConfig.coopSettings.ecommerce.page.segmentUrl,
        type: 'Container',
    };
    rootNode.nodes = tree?.map((x) => mapToMenu(x, [rootNode])) || [];

    return rootNode;
};
